import { cx } from "../../Util/classHelpers";
import MultiDropDownComponent from "../Analytics/multiDropDownComponent";
import styles from "./reviews-page.module.css";
import CustomSelect from "../CommonComponents/select/CustomSelect";
import {
  timeFrameOptions,
  orderRatingOptions,
  driverRatingOptions,
  orderTypeOptions,
  sortByOptions,
  actions,
} from "./reviewListReducer";
import { useSelector } from "react-redux";
import { useEffect } from "react";

const ReviewsFilters = ({ state, dispatch }) => {
  const selectedCompanyIds = useSelector((state) => state.companyIdList);

  useEffect(() => {
    dispatch({
      type: actions.SET_COMPANY_IDS,
      companyIds: selectedCompanyIds?.companyList ?? [],
    });
  }, [selectedCompanyIds, dispatch]);

  return (
    <>
      <div
        className={cx(
          styles.companyFilterContainer,
          "overwrite-multi-dropdown-width"
        )}
      >
        <MultiDropDownComponent allText="Select All Stores" />
      </div>

      <div className={styles.filterButtonsContainer}>
        <CustomSelect
          options={timeFrameOptions}
          selected={state.timeFrame}
          onSelect={(value) =>
            dispatch({ type: actions.SET_TIME_FRAME, timeFrame: value })
          }
        />
        <CustomSelect
          options={orderRatingOptions}
          selected={state.orderRating}
          onSelect={(value) =>
            dispatch({ type: actions.SET_ORDER_RATING, orderRating: value })
          }
        />
        <CustomSelect
          options={driverRatingOptions}
          selected={state.driverRating}
          onSelect={(value) =>
            dispatch({ type: actions.SET_DRIVER_RATING, driverRating: value })
          }
        />
        <CustomSelect
          options={orderTypeOptions}
          selected={state.orderType}
          onSelect={(value) =>
            dispatch({ type: actions.SET_ORDER_TYPE, orderType: value })
          }
        />
        <CustomSelect
          options={sortByOptions}
          selected={state.sort}
          onSelect={(value) =>
            dispatch({ type: actions.SET_SORT, sort: value })
          }
        />
      </div>
    </>
  );
};
export default ReviewsFilters;
